export const GetQueryString = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = decodeURIComponent(window.location.search).substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return '';
};
